"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.getTests = exports.getFeatures = void 0;

var _extends4 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

// Add debug messages that check if people are not doing something stupid
// https://stackoverflow.com/questions/7616461/generate-a-hash-from-string-in-javascript
// A simple and quick string hash, chosen for speed and good-enough uniqueness
var hash = function hash(str) {
  return str.split("").map(function (c) {
    return c.charCodeAt(0);
  }) // eslint-disable-next-line no-bitwise
  .reduce(function (h, c) {
    return Math.abs(h * 31 + c | 0);
  }, 0);
};

function matchesTraffic(_ref) {
  var userAgent = _ref.userAgent,
      language = _ref.language,
      affiliate = _ref.affiliate,
      country = _ref.country,
      _ref$traffic = _ref.traffic,
      traffic = _ref$traffic === void 0 ? {} : _ref$traffic;
  var uaOk = traffic.userAgent == null || new RegExp(traffic.userAgent).test(userAgent);
  var langOk = traffic.languages == null || traffic.languages.includes(language);
  var affiliateOk = traffic.affiliates == null || traffic.affiliates.includes(affiliate);
  var countryOk = traffic.countries == null || traffic.countries.includes(country);
  return uaOk && langOk && affiliateOk && countryOk;
}

var getGroup = function getGroup(_ref2) {
  var groups = _ref2.groups,
      userAgent = _ref2.userAgent,
      language = _ref2.language,
      affiliate = _ref2.affiliate,
      country = _ref2.country,
      salt = _ref2.salt;
  var candidates = groups.filter(function (_ref3) {
    var traffic = _ref3.traffic;
    return matchesTraffic({
      traffic: traffic,
      userAgent: userAgent,
      language: language,
      affiliate: affiliate,
      country: country
    });
  });

  if (candidates.length === 0) {
    return null;
  }

  var h = hash(salt.slice(0, salt.length / 2));
  var _candidates = candidates[h % candidates.length],
      name = _candidates.name,
      tests = _candidates.tests;
  return {
    name: name,
    tests: tests
  };
};

var getSaved = function getSaved(_ref4) {
  var groups = _ref4.groups,
      userAgent = _ref4.userAgent,
      language = _ref4.language,
      affiliate = _ref4.affiliate,
      country = _ref4.country,
      savedGroup = _ref4.savedGroup;

  if (groups.length === 0 || savedGroup == null) {
    return null;
  }

  var candidate = groups.find(function (g) {
    return g.name === savedGroup;
  });

  if (candidate == null) {
    return null;
  }

  var traffic = candidate.traffic,
      name = candidate.name,
      tests = candidate.tests;
  var matches = matchesTraffic({
    traffic: traffic,
    userAgent: userAgent,
    language: language,
    affiliate: affiliate,
    country: country
  });

  if (!matches) {
    return null;
  }

  return {
    name: name,
    tests: tests
  };
};

function getGroupTests(tests, salt) {
  var saltTests = salt.slice(salt.length / 2, salt.length);
  var saltOffset = saltTests.length / tests.length;

  if (saltTests.length < tests.length) {
    /* eslint-disable no-console */
    console.warn("[@kiwicom/darwin] Too many tests (" + saltTests.length + ") for the salt length.");
    console.warn("[@kiwicom/darwin] Please reduce the maximum number of tests per group.");
    /* eslint-enable no-console */
  }

  return tests.map(function (test, i) {
    // Chunks the salt to multiple smaller bits, each bit used for a different test
    var h = hash(saltTests.slice(saltOffset * i, saltOffset * (i + 1)));
    var weightedValues = test.values.reduce(function (acc, next) {
      return acc.concat(Array(next.weight).fill(next.value));
    }, []);
    return {
      name: test.name,
      value: weightedValues[h % weightedValues.length]
    };
  });
}

var getTests = function getTests(_ref5) {
  var config = _ref5.config,
      _ref5$userAgent = _ref5.userAgent,
      userAgent = _ref5$userAgent === void 0 ? "" : _ref5$userAgent,
      _ref5$language = _ref5.language,
      language = _ref5$language === void 0 ? "" : _ref5$language,
      _ref5$affiliate = _ref5.affiliate,
      affiliate = _ref5$affiliate === void 0 ? "" : _ref5$affiliate,
      _ref5$country = _ref5.country,
      country = _ref5$country === void 0 ? "" : _ref5$country,
      salt = _ref5.salt,
      savedGroup = _ref5.savedGroup;
  var _config$groups = config.groups,
      groups = _config$groups === void 0 ? [] : _config$groups; // UUIDv4 is a common format used here, this ensures the dashes do not
  // cause slight bias during group and test assignments.

  var saltPurified = salt.replace(/[^a-z0-9]/gi, "");
  var saved = getSaved({
    groups: groups,
    userAgent: userAgent,
    language: language,
    affiliate: affiliate,
    country: country,
    savedGroup: savedGroup
  });

  if (saved !== null) {
    return {
      group: saved.name,
      tests: getGroupTests(saved.tests, saltPurified)
    };
  }

  var group = getGroup({
    groups: groups,
    userAgent: userAgent,
    language: language,
    affiliate: affiliate,
    country: country,
    salt: saltPurified
  });

  if (group !== null) {
    return {
      group: group.name,
      tests: getGroupTests(group.tests, saltPurified)
    };
  }

  return {
    group: null,
    tests: []
  };
};

exports.getTests = getTests;

var getFeatures = function getFeatures(_ref6) {
  var config = _ref6.config,
      _ref6$userAgent = _ref6.userAgent,
      userAgent = _ref6$userAgent === void 0 ? "" : _ref6$userAgent,
      _ref6$language = _ref6.language,
      language = _ref6$language === void 0 ? "" : _ref6$language,
      _ref6$affiliate = _ref6.affiliate,
      affiliate = _ref6$affiliate === void 0 ? "" : _ref6$affiliate,
      _ref6$country = _ref6.country,
      country = _ref6$country === void 0 ? "" : _ref6$country;
  var _config$features = config.features,
      features = _config$features === void 0 ? [] : _config$features;
  return features.reduce(function (acc, _ref7) {
    var _extends3;

    var traffic = _ref7.traffic,
        name = _ref7.name,
        enabled = _ref7.enabled;

    if (matchesTraffic({
      traffic: traffic,
      userAgent: userAgent,
      language: language,
      affiliate: affiliate,
      country: country
    })) {
      var _extends2;

      return (0, _extends4.default)({}, acc, (_extends2 = {}, _extends2[name] = enabled, _extends2));
    }

    return (0, _extends4.default)({}, acc, (_extends3 = {}, _extends3[name] = false, _extends3));
  }, {});
};

exports.getFeatures = getFeatures;